import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-tabitpay-diner-dialog',
    templateUrl: './tabitpay-diner-dialog.component.html',
    styleUrl: './tabitpay-diner-dialog.component.scss',
    standalone: false
})
export class TabitpayDinerDialogComponent {

	constructor(
		public dialogRef: MatDialogRef<TabitpayDinerDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public appService: AppService,
	) {
		let _data = this.data;
		console.log(_data);
	}

	cancel() {
		this.dialogRef.close();
	}

	apply(mode) {
		this.dialogRef.close(mode);
	}

}
